var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseFormField',{attrs:{"slim-margin":"","label":_vm.label,"variant":_vm.variant}},[_c('span',{staticClass:"form-field-read-only__text"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }